export const INITIAL_PRODUCTS = [
  {
    id: '1',
    name: 'Boiler Shack',
    description: 'Custom-built boiler shacks for oil and gas operations',
    image_url: '/images/products/boiler_shack.jpg'
  },
  {
    id: '2',
    name: 'Combination Shack',
    description: 'Multi-purpose combination shacks for field operations',
    image_url: '/images/products/combination_shack.jpg'
  },
  {
    id: '3',
    name: 'Mud Tank',
    description: 'Heavy-duty mud tanks for drilling operations',
    image_url: '/images/products/mud_tank.jpg'
  },
  {
    id: '4',
    name: 'Flare Tank',
    description: 'Flare tanks designed for safe gas burning operations',
    image_url: '/images/products/flare_tank.jpg'
  },
  {
    id: '5',
    name: 'Surface Drilling Rig',
    description: 'Custom surface drilling rig fabrication',
    image_url: '/images/products/surface_drilling_rig.jpg'
  },
  {
    id: '6',
    name: 'Pipe Racks',
    description: 'Durable pipe racks for storage and transportation',
    image_url: '/images/products/pipe_racks.jpg'
  },
  {
    id: '7',
    name: 'Service Deck',
    description: 'Heavy-duty service decks for oilfield operations',
    image_url: '/images/products/service_deck.jpg'
  },
  {
    id: '8',
    name: 'Water Tank & Dog House',
    description: 'Water tanks with integrated dog house structures',
    image_url: '/images/products/water_tank_dog_house.jpg'
  }
];

export const INITIAL_SERVICES = [
  {
    id: '1',
    name: 'Millwright',
    description: 'Professional millwright services for industrial equipment installation and maintenance',
    icon: 'Settings'
  },
  {
    id: '2',
    name: 'Machining',
    description: 'Precision machining services for custom parts and repairs',
    icon: 'Cog'
  },
  {
    id: '3',
    name: 'Welding',
    description: 'Expert welding services for all types of metal fabrication',
    icon: 'Flame'
  },
  {
    id: '4',
    name: 'Plant Maintenance',
    description: 'Comprehensive plant maintenance services to keep your operations running smoothly',
    icon: 'Wrench'
  },
  {
    id: '5',
    name: 'Rig and Oilfield Service',
    description: 'Specialized services for rig and oilfield equipment',
    icon: 'Drill'
  },
  {
    id: '6',
    name: 'General Fabrication and Repairs',
    description: 'Custom fabrication and repair services for all industrial needs',
    icon: 'Hammer'
  },
  {
    id: '7',
    name: 'Pressure Welding',
    description: 'Certified pressure welding for critical applications',
    icon: 'Zap'
  },
  {
    id: '8',
    name: 'TIG Stainless',
    description: 'Specialized TIG welding for stainless steel applications',
    icon: 'Shield'
  },
  {
    id: '9',
    name: 'Pipeline',
    description: 'Pipeline welding and fabrication services',
    icon: 'Network'
  }
];

export const SUPPLIES_LIST = [
  { name: 'Shafts', description: 'Steel, chrome, stainless, brass' },
  { name: 'Structural Steel', description: 'Flat bars, angles, channels, rounds, squares, plates, flanges' },
  { name: 'Piping', description: 'Pipes, square/rectangular tubings, weld elbows, pipe fittings' },
  { name: 'Safety Grating', description: 'Safety/Bar Grating, checkered plates, floor plates, QT plates' },
  { name: 'Fasteners', description: 'Nuts & bolts - all styles & sizes' },
  { name: 'Hardware', description: 'Weld-on hinges, slam locks' },
  { name: 'Aluminum Products', description: 'Various aluminum supplies' },
  { name: 'Custom Items', description: 'And more... Call for availability' }
];

export const COMPANY_INFO = {
  name: 'Eastend Iron Industries Ltd.',
  tagline: 'Specializing in Shop & Portable',
  founded: '1975',
  location: 'Taber, Alberta',
  shopSize: '20,000 square feet',
  facilities: '3 fabrication facilities',
  about: `Founded in 1975, Eastend Iron Industries Ltd. is a Southern Alberta based company that specializes in steel fabricated products and welding services for the agriculture and oil industries. In 1995, Eastend Iron underwent a major operation overhaul. Since then, it has been continuously expanding and improving in capabilities to adapt to the fast growing customer's demands. Currently, it has 20,000 square feet of shop floor spreading over 3 fabrication facilities in Taber, Alberta.`,
  commitment: 'As a team of qualified professionals, we are committed to high quality standards and on time deliveries. Our success depends on your satisfaction with our products and services.'
};

export const CONTACT_INFO = {
  phone: '(403) 223-2620',
  fax: '(403) 223-8626',
  email: 'george@eastendiron.com',
  address: '6215 - 54 Avenue',
  city: 'Taber',
  province: 'AB',
  postal_code: 'T1G 1X4',
  country: 'Canada'
};